import { Link, DropIcon } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import * as S from './NavItem.styled'

export const NavItem = ({
  text,
  link,
  dropdown,
  selected,
  onClick,
  children,
  disabled,
  responsiveColor,
  ...props
}) => {
  const textColor = responsiveColor ? 'gray1' : 'lockedWhite'

  return (
    <Link href={link} disabled={disabled}>
      <Flex
        margin="0 24px"
        align="stretch"
        justify="center"
        height="100%"
        clickable
        {...props}
      >
        <S.NavItem selected={selected} center onClick={onClick}>
          <Text color={textColor}>{text}</Text>
          {dropdown && (
            <DropIcon up={selected} fill={textColor} margin="0 0 0 12px" />
          )}
        </S.NavItem>
        {children}
      </Flex>
    </Link>
  )
}

export default NavItem
